import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=3d223888&"
import script from "./DataList.vue?vue&type=script&lang=js&"
export * from "./DataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d223888')) {
      api.createRecord('3d223888', component.options)
    } else {
      api.reload('3d223888', component.options)
    }
    module.hot.accept("./DataList.vue?vue&type=template&id=3d223888&", function () {
      api.rerender('3d223888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/widgets/processing/DataList.vue"
export default component.exports